import React, { useEffect, useContext } from 'react';
import Flow from 'components/common/flow/flow';
import Heading from 'components/common/heading/heading';
import SiteContext from 'components/shared/siteContext/siteContext';
import Panel from 'components/common/panel/panel';
import AppContext from 'contexts/appContext';
import './siteAttributeViewerPage.css';

const spcwinregistrationattributes = [
  { name: 'License Key', value: '15144' },
  { name: 'Hardware Signature', value: '0AFB90FB3E9A6548' },
  { name: 'PC Key Status', value: 'Registered' },
  { name: 'HW Key Status', value: 'Disabled' },
  { name: 'License Mode', value: '	PC License' },
  { name: 'License Status', value: 'No Error' },
  { name: 'Last Ping Date', value: '9/11/2019 3:29 AM' },
  { name: 'Last Ping Status', value: 'Error Code 0 (Success)' },
];

export default function SiteAttributeViewerPage(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  useEffect(() => {
    setAppArea(AppContext.Areas.BackofficeReports, 'Site Details');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Site Details', selected: true }]);
  }, []);

  return (
    <Flow>
      <Flow.Header>
        <Heading>
          <SiteContext.Button hierarchyId={141} />
          <div className='flex-grow-1 d-flex justify-content-end'>
            <a href='/SiteManager' className='btn btn-default btn-md'>
              Manage Site
            </a>
          </div>
        </Heading>
      </Flow.Header>

      <Flow.Body>
        <div className='row justify-content-md-center mx-0 mt-4'>
          <div className='col-12 col-md-10 col-xl-8'>
            <Panel>
              <Panel.Header>SpcWin Attributes</Panel.Header>
              <Panel.Body>
                <SpcwinAttributes />
              </Panel.Body>
            </Panel>
          </div>
        </div>
      </Flow.Body>
    </Flow>
  );
}

function SpcwinAttributes(props) {
  return (
    <div className='row'>
      <div className='col-12 col-md-6'>
        {spcwinregistrationattributes.slice(0, (spcwinregistrationattributes.length / 2)).map((item, index) => Attribute(item.name, item.value))}
      </div>
      <div className='col-12 col-md-6'>
        {spcwinregistrationattributes.slice((spcwinregistrationattributes.length / 2), spcwinregistrationattributes.length).map((item, index) => Attribute(item.name, item.value))}
      </div>
    </div>
  );
}

function Attribute(label, value) {
  return (
    <div className='mb-2'>
      <div><div className='form-label'>{label}</div></div>
      <div>{value}</div>
    </div>
  );
}